var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_30174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9996C18.6274 23.9996 24 18.6269 24 11.9996C24 10.5317 23.736 9.12562 23.2536 7.82568H0.746391C0.264047 9.12562 0 10.5317 0 11.9996C0 18.6269 5.37262 23.9996 12 23.9996Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 23.9997C17.1598 23.9997 21.5583 20.7432 23.2538 16.1736H0.746582C2.4421 20.7432 6.84061 23.9997 12.0002 23.9997Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10254 6.78198V12.7682C3.10254 16.1734 7.55102 17.2168 7.55102 17.2168C7.55102 17.2168 11.9995 16.1734 11.9995 12.7682V6.78198H3.10254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14648 6.78198V12.7682C4.14648 13.168 4.23527 13.5455 4.41114 13.8994C6.15648 13.8994 8.76517 13.8994 10.6918 13.8994C10.8677 13.5455 10.9564 13.168 10.9564 12.7682V6.78198H4.14648Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63874 10.9561H8.07358V9.91261H9.11707V8.86912H8.07358V7.82568H7.03009V8.86912H5.98666V9.91261H7.03009V10.9561H5.46484V11.9996H7.03009V13.0431H8.07358V11.9996H9.63874V10.9561Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8344 15.3572C6.50682 15.7798 7.19766 16.0251 7.55134 16.1342C7.90501 16.0251 8.59585 15.7798 9.26827 15.3572C9.94637 14.931 10.4217 14.4436 10.6916 13.9005C10.3939 13.6899 10.0307 13.5657 9.63831 13.5657C9.49543 13.5657 9.35663 13.5826 9.22318 13.6137C8.94038 12.9711 8.29843 12.5222 7.55138 12.5222C6.80434 12.5222 6.16234 12.9711 5.87959 13.6137C5.74613 13.5826 5.60729 13.5657 5.46446 13.5657C5.07207 13.5657 4.70884 13.6899 4.41113 13.9005C4.6809 14.4435 5.15626 14.9309 5.8344 15.3572Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_30174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.0185fa35c38d43ce3940ac03ea40f0e0.svg";
export { ForwardRef as ReactComponent };